import React from 'react';
import { Stack } from '@mui/material';
import {
  Card,
  ContextMenu,
  ContextMenuButton,
  ContextMenuItem,
  ListItemCardSubtitle,
  ListItemCardTitle,
  useContextMenu,
} from '@marageti/z4-lib';
import { EnchancedPartnerCountry } from '../../utils/partners/types';

type CountryCardProps = {
  onClickEdit: (partnerCountry: EnchancedPartnerCountry) => void;
  onClickRemove: (partnerCountry: EnchancedPartnerCountry) => void;
  partnerCountry: EnchancedPartnerCountry;
};

const CountryCard = ({
  onClickEdit,
  onClickRemove,
  partnerCountry,
}: CountryCardProps) => {
  const [contextMenuAnchor, setContextMenuAnchor, contextMenuOpen] = useContextMenu();
  const buttonId = `${partnerCountry.country}-context-button`;
  const menuId = `${partnerCountry.country}-context-menu`;

  const handleClickEdit = () => {
    onClickEdit(partnerCountry);
    setContextMenuAnchor(null);
  };

  const handleClickRemove = () => {
    onClickRemove(partnerCountry);
    setContextMenuAnchor(null);
  };

  return (
    <Card>
      <Stack
        direction="row"
        spacing={1}
        justifyContent="space-between"
        alignItems="center"
      >
        <Stack alignItems="space-between" minHeight="45px">
          <ListItemCardTitle>
            {partnerCountry.displayName}
          </ListItemCardTitle>
          <ListItemCardSubtitle>
            {partnerCountry.primary ? 'Primary' : 'Secondary'}
          </ListItemCardSubtitle>
        </Stack>
        <ContextMenuButton
          id={buttonId}
          open={contextMenuOpen}
          onClick={(e) => setContextMenuAnchor(e.currentTarget)}
          menuId={menuId}
        />
        <ContextMenu
          anchorEl={contextMenuAnchor}
          buttonId={buttonId}
          id={menuId}
          onClose={() => setContextMenuAnchor(null)}
          open={contextMenuOpen}
        >
          <ContextMenuItem onClick={handleClickEdit}>
            Edit
          </ContextMenuItem>
          <ContextMenuItem onClick={handleClickRemove}>
            Remove
          </ContextMenuItem>
        </ContextMenu>
      </Stack>
    </Card>
  );
};
export default CountryCard;
